import { UserInfo } from '../user/userInfo.js';
import { initPanelSlider } from './../homepage-slider/homepage-slider';
export async function initPromotionsNTournamentsWidget() {
  const moduleMD5 = await import('../tools/md5.js'),
    moduleBasicFunc = await import('../tools/basic-functions.js'),
    moduleTournamentsPrizes = await import('../tournaments/tournaments-prizes.js'),
    moduleFootnote = await import('../footnote/footnote.js');
  //config
  let promotionsListEl = document.querySelector('.panels.promotions-n-tournaments'),
    userProfile = _CMS_USER_PROFILE ?? [];

  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();

  if (isLogged && Array.isArray(userProfile)) {
    userProfile.push(moduleMD5.md5('s-active'));
  } else {
    userProfile = moduleMD5.md5('s-inactive');
  }
  let langLocale = _CMS_LANGUAGE;
  if (_CMS_LOCALE != '') langLocale = _CMS_LOCALE;
  // let jsonURL = '/' + _CMS_LANGUAGE + '/json/promotions';

  let jsonLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
  let jsonURL = '/' + jsonLocale + '/json/promotions';

  const data = await moduleBasicFunc.getJSON(jsonURL);
  if (!data?.promotions) {
    return;
  }

  for (let i = 0, len = data.promotions.length; i < len; i++) {
    var item = data.promotions[i];
    if (
      item.country_restriction_type == 'Global' ||
      (item.country_restriction_type == 'Allowance mode' &&
        ((item.country_restriction_config == '' && $('.promotions-list').attr('data-mode') == 'preview') ||
          item.country_restriction_config.indexOf(_CMS_USERIP) >= 0)) ||
      (item.country_restriction_type == 'Restriction mode' &&
        item.country_restriction_config.indexOf(_CMS_USERIP) == -1)
    ) {
      var profileCompability = false;
      if (
        item.user_restriction_type != 'Unrestricted' &&
        item.user_restriction_type != '' &&
        item.user_restriction_config != ''
      ) {
        var itemProfile = item.user_restriction_config.split(',');
        for (let i = 0, len = itemProfile.length; i < len; i++) {
          var value = itemProfile[i];
          if (userProfile.includes(value) || value == userProfile) {
            profileCompability = true;
          }
        }
      }
      if (
        item.add_to_homepage == '1' &&
        promotionsListEl.querySelectorAll('.panel[data-id="' + item.url + '"]').length == 0 &&
        item.visibility == '1' &&
        item.expired != 'y' &&
        (item.user_restriction_type == 'Unrestricted' ||
          item.user_restriction_type == '' ||
          (item.user_restriction_type == 'User allowance mode' && profileCompability) ||
          (item.user_restriction_type == 'User restriction mode' && !profileCompability))
      ) {
        var preURL = '';
        if (_CMS_PRODUCT_TYPE == 'casino' && item.category == 'sportsbook') {
          preURL = 'https://energybet.com';
        }
        if (_CMS_PRODUCT_TYPE == 'sportsbook' && item.category != 'sportsbook') {
          preURL = 'https://energycasino.com';
        }
        var midURL = '/promotions/terms-and-conditions/';
        if (item.category != 'sportsbook') {
          midURL = '/casino-bonus/';
        }
        preURL = preURL + '/' + langLocale + midURL;
        await createPromotionPanel(item, preURL);
      }
    }
  }
  // jsonURL = '/' + _CMS_LANGUAGE + '/json/tournaments';
  jsonLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
  jsonURL = '/' + jsonLocale + '/json/tournaments';

  const dataTournaments = await moduleBasicFunc.getJSON(jsonURL);
  if (!dataTournaments || !Array.isArray(dataTournaments.tournaments)) {
    return;
  }
  for (let i = 0, len = dataTournaments.tournaments.length; i < len; i++) {
    let item = dataTournaments.tournaments[i];
    if (
      item.country_restriction_type == 'Global' ||
      (item.country_restriction_type == 'Allowance mode' &&
        (item.country_restriction_config == '' || item.country_restriction_config.indexOf(_CMS_USERIP) >= 0)) ||
      (item.country_restriction_type == 'Restriction mode' &&
        item.country_restriction_config.indexOf(_CMS_USERIP) == -1)
    ) {
      let profileCompability = false;
      if (
        item.user_restriction_type != 'Unrestricted' &&
        item.user_restriction_type != '' &&
        item.user_restriction_config != ''
      ) {
        let itemProfile = item.user_restriction_config.split(',');
        for (let i = 0, len = itemProfile.length; i < len; i++) {
          let value = itemProfile[i];
          if (userProfile.includes(value) != '-1' || value == userProfile) {
            profileCompability = true;
          }
        }
      }
      if (
        item.status == 'active' &&
        item.add_to_homepage == '1' &&
        (item.user_restriction_type == 'Unrestricted' ||
          item.user_restriction_type == '' ||
          (item.user_restriction_type == 'User allowance mode' && profileCompability) ||
          (item.user_restriction_type == 'User restriction mode' && !profileCompability))
      ) {
        let midURL = '/tournaments/',
          preURL = '/' + langLocale + midURL;
        if (!isNaN(item.prize_pool)) {
          item.prize_pool = moduleTournamentsPrizes.getTournamentsPrizeConvertion(item.prize_pool);
        }
        await createTournamentPanel(item, preURL);
      }
    }
  }
  initPanelSlider('.promotions-n-tournaments', 4);
  moduleFootnote.initFootnotePopup(promotionsListEl);
}

async function createPromotionPanel(item, preURL) {
  const moduleTranslations = await import('../tools/translations.js');
  const { default: PanelPost } = await import('../classes/panelPost');
  let labelTranslation = await moduleTranslations.getTranslation(item.label),
    btnTextTranslation = await moduleTranslations.getTranslation('read_more');
  new PanelPost({
    mainClass: 'post-promotion',
    additionalClasses: 'panel swiper-slide',
    containerSelector: '.promotions-n-tournaments .panels-body.posts',
    imgSrc: item.list_image,
    title: item.title,
    description: item.description,
    label: labelTranslation,
    btnText: btnTextTranslation,
    legalinfo: item.footnote,
    link: preURL + item.url
  });
}

async function createTournamentPanel(item, preURL) {
  const moduleTranslations = await import('../tools/translations.js');
  const { default: PanelPost } = await import('../classes/panelPost');
  let btnTextTranslation = await moduleTranslations.getTranslation('join_tournament'),
    typeTranslation = await moduleTranslations.getTranslation('tournaments_' + item.type),
    panelEl = new PanelPost({
      mainClass: 'post-tournament',
      additionalClasses: 'panel swiper-slide',
      containerSelector: '.promotions-n-tournaments .panels-body.posts',
      backgroundSrc: item.background,
      title: item.title,
      description: item.summary,
      label: typeTranslation,
      btnText: btnTextTranslation,
      legalinfo: item.footnote,
      isTournament: true,
      icon: item.icon,
      prizePool: item.prize_pool,
      link: preURL + item.url
    });
  initTimer(panelEl.getElement(), item.end_date);
}

function initTimer(tournamentItem, countdown) {
  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;
  let countdownDate = new Date(countdown).getTime(),
    interval = setInterval(() => {
      let now = new Date().getTime(),
        distance = countdownDate - now;

      const daysEl = tournamentItem.querySelector('.days'),
        hoursEl = tournamentItem.querySelector('.hours'),
        minutesEl = tournamentItem.querySelector('.minutes'),
        secondsEl = tournamentItem.querySelector('.seconds');
      if (daysEl) {
        daysEl.innerText = String(Math.floor(distance / day)).padStart(2, '0') + 'd';
      }
      if (hoursEl) {
        hoursEl.innerText = String(Math.floor((distance % day) / hour)).padStart(2, '0');
      }
      if (minutesEl) {
        minutesEl.innerText = String(Math.floor((distance % hour) / minute)).padStart(2, '0');
      }
      if (secondsEl) {
        secondsEl.innerText = String(Math.floor((distance % minute) / second)).padStart(2, '0');
      }

      if (distance < 0) {
        clearInterval(interval);
      }
    }, 1000);
}
